module.exports = __webpack_public_path__ + "static/cert-data-arch-designer-276dd5b598d92b2e3ce3b3e446d2a23f.png";